// useBaseVocabulary.js

import { useMemo } from 'react';

import { useBase } from 'context/BaseContext';
import { getBaseVocabulary } from 'utilities/baseVocabulary';

/**
 * Labels for the active base (pack stamp or defaults).
 *
 * @returns {{ baseLabel: string, baseLabelPlural: string, iconKey: string }}
 */
export default function useBaseVocabulary() {
  const { activeBase } = useBase();
  return useMemo(() => getBaseVocabulary(activeBase), [activeBase]);
}
